import { Box, Chip, CircularProgress, SxProps, Typography, useTheme } from '@mui/material';

interface JobMatchScoreProps {
  score: number;
  variant?: 'small' | 'normal';
  sx?: SxProps;
}

function JobMatchScore({
  variant = 'normal',
  score,
  sx = {},
}: JobMatchScoreProps): React.ReactElement {
  const theme = useTheme();
  const getMatchColor = (value: number): string => {
    if (value >= 80) return theme.palette.success.main;
    if (value >= 60) return theme.palette.info.main;
    if (value >= 40) return theme.palette.warning.main;
    return theme.palette.error.main;
  };
  const suffix = variant === 'small' ? '' : ' Match';

  return (
    <Box
      className="JobMatchScore"
      sx={{
        justifyContent: 'center',
        m: 0,
        p: 0,
        width: variant === 'small' ? '8rem' : '10rem',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        ...sx,
      }}
    >
      <Chip
        label={
          score >= 80
            ? `Excellent${suffix}`
            : score >= 60
            ? `Good${suffix}`
            : score >= 40
            ? `Partial${suffix}`
            : `Low${suffix}`
        }
        sx={{
          bgcolor: getMatchColor(score),
          color: 'white',
          fontWeight: 'bold',
          fontSize: variant === 'small' ? '0.7rem' : '1rem',
        }}
      />
      {variant !== 'small' && (
        <Box sx={{ position: 'relative', display: 'inline-flex', p: 0, m: 0 }}>
          <CircularProgress
            variant="determinate"
            value={score}
            size={60}
            thickness={5}
            sx={{ color: getMatchColor(score) }}
          />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant="caption"
              component="div"
              sx={{ fontWeight: 'bold', fontSize: '1rem' }}
            >
              {`${Math.round(score)}%`}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export { JobMatchScore };
